import { useOrderIdParam } from './useOrderIdParam'
import isEmpty from 'lodash/isEmpty'
import { getOtherStripeInfos } from './useStripeInfo'
import type { UseDocumentProps, UseDocumentResult } from '@ztechapps/common.hook'
import { useQueryEffect } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'
import { useState } from 'react'
import { queries } from '../graphql'
import { useOrderDocument as useOrderDocumentCore } from '@ztechapps/order.common'

export const useOrderById = (props?: Partial<UseDocumentProps>) => {
  const orderId = useOrderIdParam()

  return useOrderDocumentCore({ ...props, _id: orderId, ...queries.singleConfig })
}

export const useOrderDocument = (props?: Partial<UseDocumentProps>) => {
  const orderDocumentResult = useOrderById(props)
  const [finalResult, setFinalResult] = useState<UseDocumentResult<Order>>(orderDocumentResult)

  useQueryEffect(() => {
    const newDocument = { ...orderDocumentResult?.document }

    const payments = []
    if (!isEmpty(newDocument?.payment)) {
      const otherInfos = getOtherStripeInfos({ payment: newDocument?.payment })
      payments.push({
        ...newDocument?.payment,
        ...otherInfos,
      })
    }

    if (!isEmpty(newDocument?.payments)) {
      for (const payment of newDocument?.payments ?? []) {
        const otherInfos = getOtherStripeInfos({ payment })

        payments.push({
          ...payment,
          ...otherInfos,
        })
      }
    }

    newDocument.payments = payments

    //return with the new value of document
    const result = { ...orderDocumentResult, document: newDocument } as UseDocumentResult<Order>

    setFinalResult(result)
  }, orderDocumentResult)

  return finalResult
}
